module.exports = __webpack_public_path__ + "static/media/sair_active.769f84bb.svg";